import React from 'react'

const Footer = () => {
  return (
    <footer>

   
      <div className='sooter'>
        <h1>SHIVAM PUBLIC SCHOOL</h1>
        <p>@all rights reserved</p>
      </div>

      <div>
      <h5>Connect With Us</h5>
        {/* <div>
         
          <a href="https://www.instagram.com/nirmal_mishra_official/" target={"blank"}>
            Instagram
          </a>
          <a href="https://www.facebook.com/nirmal.mishra.9" target={"blank"}>
            Facebook
          </a>
          <a href="mailto:mishranirmal518@gmail.com">Email </a>
         
        </div> */}
      </div>
    </footer>
  )
}

export default Footer;